function Markets() {
  return (
    <section className="markets-section" id="markets">
      <div className="wrap">
        <div className="section-head market-heading">
          <div className="eyebrow">Our markets</div>
          <h2>
            <span className="intro-title-line">Distinct</span>
            <span className="intro-title-line">local foundations.</span>
          </h2>
          <p>Our Kenya and Tanzania operations are presented independently, reflecting their respective leadership, market environments and client relationships—while benefiting from shared international advisory expertise.</p>
        </div>
        <div className="country-grid">
          <article className="country-card kenya">
            <div className="country-top">
              <span className="country-code">KE</span>
              <span className="country-city">Nairobi</span>
            </div>
            <h3>WillMars Reinsurance Brokers (EA) Limited</h3>
            <div className="address-line">
              The Mirage Towers, Chiromo Road, Westlands District, Westlands, P.O Box 79012 Tom Mboya St, Nairobi, Kenya
            </div>
            <p><strong>Led by Alfred F. Crasto, Managing Director</strong>, with Anuraag Kaul serving as Director.</p>
            <ul>
              <li>Treaty reinsurance programme design and placement</li>
              <li>Facultative placement for large and complex risks</li>
              <li>Portfolio analysis, risk advisory and inspections</li>
              <li>Claims, technical and market support</li>
            </ul>
            <div className="licence-line">
              <span className="licence-line-row">IRA Licensed Reinsurance Broker · IRA/06R/032/2026 · Valid to 31 December 2026</span>
              <span className="licence-line-row licence-line-row--next">Company Number: PVT-5JUER778</span>
            </div>
          </article>
          <article className="country-card tanzania">
            <div className="country-top">
              <span className="country-code">TZ</span>
              <span className="country-city">Dar es Salaam</span>
            </div>
            <h3>WillMars Reinsurance Brokers Limited</h3>
            <div className="address-line">
              1st Floor, VIVA Tower, Suite No 06, Ally Hassan Mwinyi Rd, Po.Box 38346, Dar Es Salaam Tanzania
            </div>
            <p><strong>Led by Adarsh Sharma, Chairman</strong>, with Anuraag Kaul serving as Director.</p>
            <ul>
              <li>Treaty reinsurance programme design and placement</li>
              <li>Facultative placement for large and complex risks</li>
              <li>Portfolio analysis, risk advisory and inspections</li>
              <li>Claims, technical and market support</li>
            </ul>
            <div className="licence-line">BRELA Business License 20000108035 · TIN 139-898-893 · Valid to 26 January 2027</div>
          </article>
        </div>
      </div>
    </section>
  )
}

export default Markets
